import React, { Component } from "react";
import "./footer.scss";
class Subscribe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      entityId: props.entity.id,
      entityType: props.entity.entityType,
    };
  }

  render() {
    const { activepipe } = this.props.entity.siteOptions;
    if (!activepipe || !activepipe.show || !activepipe.signUpUrl) {
      return null;
    }
    return (
      <div className="footer-subscribe">
        <div className="container web-container">
          <div className="row">
            <div className="col-xs-16 col-sm-8">
              <h4>Sign Up For Updates</h4>
              <p>
                Subscribe to receive the latest real estate market updates,
                exclusive new listings, architecture & design inspiration and
                more.
              </p>
            </div>
            <div className="col-xs-16 col-sm-8 signup-outer">
              <div className="signup">
                <a href={activepipe.signUpUrl} target="_blank">
                  <button className="aw-button">Sign Up</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Subscribe;



// WEBPACK FOOTER //
// ./src/components/shared/footer/subscribe.js